import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from 'src/app/services/master.service';
import { ContactRequest } from 'src/app/models/contact.model';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {
  @Input() formGroupName: string;
  registerForm: FormGroup;

  registerType = [];
  dep = [];
  pro = [];
  dis = [];
  contact = [];
  invalidForm = true;

  loadProvin: boolean = true;
  loadingProvin: boolean = false;
  loadDis: boolean = true;
  loadingdDis: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private masterService: MasterService,
    private rootFormGroup: FormGroupDirective
  ) {
  }

  ngOnInit(): void {
    this.registerForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.getListDep();
    this.getregisterType();
  }

  onNoClick(): void {
    this.activeModal.close();
  }

  //#region [Ubigeo]
  getListDep() {
    this.masterService.getList(3, 0).subscribe(
      (response: any) => {
        this.dep = response;
      }
    );
  }

  getListProv(event: number): void {
    if (!event) { return; }
    this.loadProvin = true; this.pro = []; this.loadingProvin = true;
    this.loadDis = true; this.dis = [];
    this.masterService.getList(4, event).subscribe(
      (response: any) => {
        this.pro = response;
        this.loadProvin = false; this.loadingProvin = false;
      }
    );
  }

  getListDistritc(event: number) {
    if (!event) { return; }
    this.loadDis = true; this.dis = []; this.loadingdDis = true;
    this.masterService.getList(5, event).subscribe(
      (response: any) => {
        this.dis = response;
        this.loadDis = false; this.loadingdDis = false;
      }
    );
  }
  //#endregion

  //#region [Util]
  getregisterType() {
    this.masterService.getList(11, 0).subscribe(
      (response: any) => {
        this.registerType = response;
      }
    );
  }

  keypress(event) {
    var regex = new RegExp('^[a-zA-ZZñÑáéíóúÁÉÍÓÚ .ñ\-]+$');
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }

  keypressNumber(event) {
    var regex = new RegExp('^[0-9]+$');
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  //#endregion
}
